import React, { useState } from 'react';
import { ToolbarItemProps } from '../../store/slice';
import {
  ExpandableItemBtn,
  ExpandableItemWrapper,
  MobileDropdownIcon,
  MobileSideNavItemText,
} from './styles';
import ExpandedMenuItemList from './ExpandedMenuItemList';
import { useSidenavBundle } from 'src/providers/PantherLocalizationProvider';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const ExpandableMenuItem: React.VFC<ToolbarItemProps> = (
  item: ToolbarItemProps,
) => {
  const bundle = useSidenavBundle();
  const [isExpanded, setIsExpanded] = useState(() =>
    item.sidebarGroups
      .map((group) =>
        group.links
          .map((link) => link.isSelected)
          .reduce((result, isSelected) => result || isSelected, false),
      )
      .reduce((result, isSelected) => result || isSelected, false),
  );

  const onClickHandler = () => {
    setIsExpanded(!isExpanded);
  };

  const title = item.toolTip || item.sidebarGroups[0].title;
  const itemId = item.id || item.sidebarGroups[0].links[0].id;
  const expandableItemBtnAriaLabel = (
    !isExpanded
      ? bundle.getMessage('sidenav-show-links-aria-label')
      : bundle.getMessage('sidenav-hide-links-aria-label')
  ).replace('{title}', title ?? '');

  return (
    <ExpandableItemWrapper isExpanded={isExpanded}>
      <ExpandableItemBtn
        onClick={onClickHandler}
        {...getTaktAttributes(itemId, chromeComponents.HEADER)}
        aria-label={expandableItemBtnAriaLabel}
        aria-expanded={isExpanded}
        data-ccx-e2e-id={itemId}
      >
        <img src={item.iconPath} alt={item.toolTip} />
        <MobileSideNavItemText>{title}</MobileSideNavItemText>
        <MobileDropdownIcon type={isExpanded ? 'angle-up' : 'angle-down'} />
      </ExpandableItemBtn>
      {isExpanded && (
        <ExpandedMenuItemList
          sidebarGroups={item.sidebarGroups}
          sidebarGroupTitle={title}
        />
      )}
    </ExpandableItemWrapper>
  );
};

export default ExpandableMenuItem;
